<template>
    <div class="tags-header mb-30px">
        <h1 v-if="title">{{title}}</h1>
        <p v-if="description">{{description}}</p>
        <tags-filter-bar />
    </div>
</template>

<script>
import TagsFilterBar from '../dynamic/TagsFilterBar.vue'

export default {
    name: 'TagsHeader',
    props: ['title', 'description'],
    components: {
        TagsFilterBar
    },
    data() {
        return {

        }
    }
}
</script>